import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LoadingScreen.css'; // Create this for styling


const LoadingScreen = ({ onBackToLogin }) => {

    const navigate = useNavigate();

    const [approved, setApproved] = useState(null);
    const [branch, setBranch] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const interval = setInterval(() => {
            if (!submitted) {
                fetch('/api/check_approval_status', {
                    credentials: 'include',
                })
                    .then(res => {
                        if (!res.ok) throw new Error('Network response was not ok');
                        return res.json();
                    })
                    .then(data => {
                        if (data.approved) {
                            window.location.href = '/home'; // Redirect once approved
                        } else {
                            setShowForm(true);
                        }
                    })
                    .catch(() => setError('Error checking approval status'));
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [submitted]);

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch('/api/submit_branch_selection', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ branch })  // body data
        })
            .then(res => {
                if (!res.ok) throw new Error('Submission failed');
                return res.json();
            })
            .then(() => setSubmitted(true))
            .catch(() => setError('Submission failed'));
    };

    const handleBackToLogin = async () => {
        try {
            await fetch('/api/logout', {
                method: 'POST',
                credentials: 'include',
            });
            onBackToLogin();        // clears frontend user state
            navigate('/');          // go back to login
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    return (
        <div className="loading-container">
            <div className="loader-spinner"></div>
            <h1>Loading your dashboard...</h1>

            {error && <p className="error">{error}</p>}

            {showForm && !submitted && (
                <form className="branch-form" onSubmit={handleSubmit}>
                    <label>Select Your Branch:</label>
                    <select value={branch} onChange={(e) => setBranch(e.target.value)} required>
                        <option value="">--Choose Branch--</option>
                        <option value="Sales">Sales</option>
                        <option value="Marketing">Marketing</option>
                        <option value="HR">HR</option>
                    </select>
                    <button type="submit">Submit</button>
                </form>
            )}

            {submitted && (
                <div className="dialog">
                    <p>Your request has been sent to the admin for approval.</p>
                </div>
            )}

            <div className="bottom-button">
                <button onClick={handleBackToLogin}>Back to Login</button>
            </div>
        </div>
    );
};

export default LoadingScreen;